export default "__VITE_ASSET__DB4HT0bQ__"